export default 'https://tme.understood.org/assets/milk_dirt.b5e8cc67.png'